export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#arrow-small","viewBox":"0 0 7 12"}